module.exports = __webpack_public_path__ + "img/rusty_nail.6dfa9e0d.jpg";